import { FormControl, IconButton, Input, InputLabel, MenuItem, Select, Stack, TableCell, TableRow, TextField } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import SaveIcon from '@mui/icons-material/Save';
import DoneIcon from '@mui/icons-material/Done';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CancelIcon from '@mui/icons-material/Close';

const EditRow = ({ row, colWidths, handleUpdate, handleCancelClick }) => {

    const cantidadRef = useRef();
    const costoRef = useRef();
    const [ubicacionState, setUbicacionState] = useState('');
    const [costoState, setCostoState] = useState('');

    useEffect(() => {
        setUbicacionState(row.ubicacion);
        setCostoState(row.costo);
        //console.log('row.costo', row.costo);
    },[])

    const handleUpdateClick = (event, row) => {
        event.preventDefault();
        const cantidad = parseInt(cantidadRef.current.value);
        const costo = parseFloat(costoState);
        const total = (cantidad * costo)
        const ubicacion = ubicacionState;
        const newRow = {...row, cantidad, costo, total, ubicacion}
        //console.log({newRow, cantidad, costo})
        handleUpdate(newRow);
    }

    const handleUbicacionChange = (event) => {
        setUbicacionState(event.target.value);
    };

    return (
        <TableRow key={'fila_' + row.id} width={colWidths.id}>
            <TableCell key={row.id} width="30">
                {row.id}
            </TableCell>
            <TableCell key={'codbar_' + row.id} width={colWidths.codBar}>
                {row.codBar}
            </TableCell>
            <TableCell key={'producto_' + row.id} width={colWidths.product}>
                {row.product}
            </TableCell>
            <TableCell key={'fecha_' + row.id} align='center' width={colWidths.vencimiento}>
                {row.vencimiento}
            </TableCell>
            <TableCell key={'ubicacion_' + row.id} align='left' width={colWidths.ubicacion}>
            <FormControl style={{ minWidth: '50%', maxWidth: 300, }}>
                        <InputLabel id="ubicacion-label"></InputLabel>
                        <Select
                            size='small'
                            labelId="ubicacion-select-label"
                            id="ubicacion-simple-select"
                            value={ubicacionState}
                            //label="Ubicación"
                            onChange={handleUbicacionChange}
                            disabled = {row.tipo == 'Pan'}
                        >
                            <MenuItem value={'Almacen'}>Almacen</MenuItem>
                            <MenuItem value={'Tienda'}>Tienda</MenuItem>
                        </Select>
                    </FormControl>
            </TableCell>
            <TableCell key={'cantidad_' + row.id} align='right' width={colWidths.cantidad}>
                <TextField size='small' type='number' inputRef={cantidadRef} required='required' placeholder='0' name='cantidad' defaultValue={row.cantidad}  />
            </TableCell>
            <TableCell key={'costo_' + row.id} align='right' width={colWidths.costo}>
                <TextField 
                    size='small' 
                    type='number' 
                    inputRef={costoRef} 
                    required='required' 
                    placeholder='0' 
                    name='costo' 
                    //defaultValue={row.costo}  
                    value={costoState}
                    onChange={(e) => setCostoState(e.target.value)}
                />
            </TableCell>
            <TableCell key={'total_' + row.id} align='right' width={colWidths.total}>
                {parseFloat(row.total).toFixed(2)}
            </TableCell>
            <TableCell key={'controles_' + row.id} align='left' width={colWidths.controles}>
                <Stack direction='row' spacing={0}>
                    <IconButton aria-label="save" onClick={(event) => handleUpdateClick(event, row)}>
                        <DoneIcon fontSize="small" />
                    </IconButton>
                    <IconButton aria-label="cancel" onClick={(event) => handleCancelClick(event, row)}>
                        <CancelIcon fontSize="small" />
                    </IconButton>
                </Stack>
            </TableCell>
        </TableRow>
    )
}

export default EditRow